export default __webpack_public_path__ + "static/image5-23c220f1d58a63618c060bf1a0508efd.jpg";